import React from 'react';
import htmlDecode from '../helpers/htmlDecode';
import toSnakeCase from '../../../helpers/to_snake_case';

const Filter = ({
  filter: { url, additional_params, num_matches },
  description,
  handleAddFilter,
}) => {
  const pluralise_match = parseInt(num_matches, 10) > 1;
  const link_id = `narrowby_link_${toSnakeCase(description)}`;
  return (
    <li className="narrow_by__criterion">
      <a
        href={`#${url}`}
        onClick={(event) => handleAddFilter(event, additional_params)}
        id={link_id}
      >
        {description}
      </a>
      <span
        className="narrow_by__matches"
        aria-label={`There ${
          pluralise_match ? 'are' : 'is'
        } ${num_matches} result${pluralise_match ? 's' : ''} for this filter`}
      >
        ({num_matches})
      </span>
    </li>
  );
};
const FilterGroup = ({ filterGroup, handleAddFilter, showFilterGroupName }) => {
  return (
    <>
      {showFilterGroupName ? (
        <h4>{htmlDecode(filterGroup.group_name)}</h4>
      ) : null}
      <ul>
        {filterGroup.narrow_options.map((filter) => {
          const description = htmlDecode(filter.desc);
          return (
            <Filter
              filter={filter}
              description={description}
              key={description}
              handleAddFilter={handleAddFilter}
            />
          );
        })}
      </ul>
    </>
  );
};

const FilterOptions = ({
  availableFilters,
  handleAddFilter,
  localisations,
  clearFilters,
  showFilterGroupName,
}) => {
  return availableFilters ? (
    <section id="narrow_by_search_options" className="narrow_by_filters">
      <header>
        <h3>{localisations.narrow_your_search}</h3>
        <a
          href={window.location}
          className="narrow_by__reset_link"
          onClick={(event) => clearFilters(event)}
        >
          {localisations.clear_filters}
        </a>
      </header>
      {availableFilters.map((filterGroup) => {
        return (
          <FilterGroup
            filterGroup={filterGroup}
            key={filterGroup.group_name}
            handleAddFilter={handleAddFilter}
            showFilterGroupName={showFilterGroupName}
          />
        );
      })}
    </section>
  ) : null;
};

export default FilterOptions;
